import PropTypes from 'prop-types';
// CORE
import React from 'react';

import Box from '@mui/material/Box';
// MUI
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const SettingsHeader = (props) => {
  const { title, primaryItem, secondaryItem, tertiaryItem, description } = props;

  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' marginBottom={3}>
      <Stack>
        <Typography variant='displayMedium'>{title}</Typography>
        <Typography variant='paragraphRegular' color='textSecondary'>
          {description}
        </Typography>
      </Stack>
      <Stack direction='row' alignItems='center' spacing={1} justifyContent='flex-end'>
        {tertiaryItem && <Box>{tertiaryItem}</Box>}
        {secondaryItem && <Box>{secondaryItem}</Box>}
        {primaryItem && <Box>{primaryItem}</Box>}
      </Stack>
    </Stack>
  );
};

SettingsHeader.propTypes = {
  className: PropTypes.string,
  primaryItem: PropTypes.any,
  secondaryItem: PropTypes.any,
  tertiaryItem: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SettingsHeader;
